import { COLORS, STATUS } from '@btime/constants'
import { capitalizeAllIfLower, fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText, Text } from '../../../../../components/presentation/Text'
import { genFormattedColumn, useRowActionsColumn } from '../../../../../components/tables/Table'
import { genNonComplianceColoringRuleColumn } from './_helpers/nonComplianceColoringColumn'
import { useNonComplianceActionsList } from '../../../../../utils/actions/nonCompliance/list'
import { useOpenNonComplianceModal } from '../../../../../utils/routes/modals/modalsActions'
import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import Link from '../../../../../components/actions/Link'
import NonComplianceStatusTag from '../../../_shared/NonComplianceStatusTag'
import NonCompliancesLoader, { useNonCompliances } from '../_load/NonCompliancesLoader'

const NonComplianceTable = () => {
  const { t } = useTranslation()

  const data = useNonCompliances()
  const openNonComplianceModal = useOpenNonComplianceModal()

  const columns = [
    {
      label: `Pergunta `,
      dataIndex: ['question', 'name'],
      sortIndex: 'QUESTION_NAME',
      flex: 3,
      render: (value, record) => (
        <Link onClick={() => openNonComplianceModal(record)} block>
          <Text size="xxsmall" bold color={COLORS.dark3} breakWord>
            {capitalizeAllIfLower(record.question?.category?.name)}
          </Text>

          <Text strong color={COLORS.dark2} breakWord>
            {capitalizeAllIfLower(value)}
          </Text>

          <SmallText size="xxsmall" color={COLORS.dark3} breakWord>
            {capitalizeAllIfLower(record.question?.checklist?.name)}
          </SmallText>
        </Link>
      )
    },

    {
      label: 'Status',
      dataIndex: 'status',
      sortIndex: 'STATUS',
      flex: 1.5,
      render: (value, record) => <NonComplianceStatusTag name={value} />
    },

    {
      label: `Aberta`,
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      render: (value, record) =>
        genNonComplianceColoringRuleColumn(value => `Aberto ${fromNow(value)}`)(value, record.status !== STATUS.OPEN),
      flex: 1.5
    },

    {
      label: `Concluida`,
      dataIndex: 'endDate',
      sortIndex: 'END_DATE',
      render: genFormattedColumn(value => value && `Concluído ${fromNow(value)}`),
      flex: 1.5
    },

    {
      label: 'Qtd. ocorrências',
      dataIndex: 'instancesCount',
      sortIndex: false,
      render: (count, record) => (
        <Link onClick={() => openNonComplianceModal(record)} block>
          <SmallText size="small" color={COLORS.dark3} breakWord>
            {count} ocorrências
          </SmallText>

          <Text size="xxsmall" color={COLORS.dark3} breakWord>
            Última vez {fromNow(record.updatedAt)}
          </Text>
        </Link>
      ),
      flex: 2
    },

    {
      label: t('actions'),
      flex: 1,
      sortIndex: false,
      render: useRowActionsColumn(useNonComplianceActionsList)
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" data={data} hideHeader />
}

const Wrapper = ({ placeId }) => (
  <NonCompliancesLoader placeId={placeId}>
    <NonComplianceTable />
  </NonCompliancesLoader>
)

export default Wrapper
